import { Inputs, OmitedInputs } from '../types';

type TParams = {
  data: Inputs;
  state: {
    isRoomArea: boolean;
    isDoorsWindowsArea: boolean;
  };
};

export const getFormData = ({ data, state }: TParams): Inputs => {
  const { windowsFields, doorsFields, ...calculatedParameters } = data;
  const omitedParameters: OmitedInputs = { ...calculatedParameters };

  Object.keys(omitedParameters).forEach(el => {
    if (omitedParameters[el as keyof OmitedInputs] === '0')
      delete omitedParameters[el as keyof OmitedInputs];
  });

  const formattedData = { ...omitedParameters, windowsFields, doorsFields };

  if (state.isRoomArea) {
    formattedData.length = '';
    formattedData.width = '';
  } else if (!state.isRoomArea) {
    formattedData.area = '';
  }
  if (state.isDoorsWindowsArea) {
    formattedData.windows = '';
    formattedData.doors = '';
  } else if (!state.isDoorsWindowsArea) {
    formattedData.windowsFields = null;
    formattedData.doorsFields = null;
  }
  return formattedData;
};
